class ArnPlpStickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.breadcrumbs = null;
    this.placeholder = document.createElement('div');

    this.isSticky = false;
    this.lastScrollY = window.scrollY;
    this.scrollTicking = false;
  }

  connectedCallback() {
    this.header = this.firstElementChild;
    if (!this.header) return;

    this.breadcrumbs = this.header.querySelector('.arn-plp-breadcrumbs');

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          this.setSticky();
        } else {
          this.unsetSticky();
        }
      },
      { threshold: 0 }
    );

    this.observer.observe(this);

    this.placeholder.style.height = `${this.offsetHeight}px`;
    this.placeholder.style.display = 'none';
    this.insertAdjacentElement('afterend', this.placeholder);

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  getBaseTopOffset() {
  if (window.visualViewport) {
    let offset = window.visualViewport.offsetTop || 0;

    // Firefox mobile sometimes reports a +1px offset due to rounding
    if (
      typeof InstallTrigger !== 'undefined' &&
      /Android/i.test(navigator.userAgent)
    ) {
      offset = Math.max(0, offset - 1);
    }

    return offset;
  }

  return 0;
}


  onScroll = () => {
    if (!this.isSticky || !this.header) return;
    if (this.scrollTicking) return;

    this.scrollTicking = true;

    requestAnimationFrame(() => {
      const currentScrollY = window.scrollY;
      const scrollingUp = currentScrollY < this.lastScrollY;

      let nextTop = `${this.getBaseTopOffset()}px`;

      if (scrollingUp) {
        const globalBanner = document.querySelector('arn-global-banner');
        const bannerHeight = globalBanner?.offsetHeight || 0;
        nextTop = `${this.getBaseTopOffset() + bannerHeight}px`;
      }

      if (this.header.style.top !== nextTop) {
        this.header.style.top = nextTop;
      }

      this.lastScrollY = currentScrollY;
      this.scrollTicking = false;
    });
  };

  setSticky() {
    if (this.isSticky || !this.header) return;
    this.isSticky = true;

    this.header.classList.add(
      'tw-fixed',
      'tw-z-[100]',
      'tw-border-1',
      'tw-border-arn-default',
      'dark:tw-border-arn-dark-default',
      '!tw-p-base',
      'tw-bg-arn-default',
      'dark:tw-bg-arn-dark-default'
    );

    this.header.style.top = `${this.getBaseTopOffset()}px`;

    if (this.breadcrumbs) {
      this.breadcrumbs.style.display = 'none';
    }

    this.header.classList.remove('tw-space-y-arn-spacings-base');
    this.header.classList.add(
      'tw-flex',
      'tw-items-center',
      'tw-justify-between',
      'tw-gap-base',
      'tw-flex-wrap'
    );

    const title = this.header.querySelector('.arn-collection-title');
    if (title) {
      title.classList.add('tw-hidden', 'sd:tw-block');
    }

    this.placeholder.style.display = 'block';

    const globalBannerSection = document.querySelector(
      '.arn-global-banner-section'
    );
    if (globalBannerSection) {
      globalBannerSection.classList.add(
        'arn-global-banner-section--sticky'
      );
    }
  }

  unsetSticky() {
    if (!this.isSticky || !this.header) return;
    this.isSticky = false;

    this.header.classList.remove(
      'tw-fixed',
      'tw-z-[100]',
      'tw-border-1',
      'tw-border-arn-default',
      'dark:tw-border-arn-dark-default',
      '!tw-p-base',
      'tw-flex',
      'tw-items-center',
      'tw-justify-between',
      'tw-gap-base',
      'tw-flex-wrap',
      'tw-bg-arn-default',
      'dark:tw-bg-arn-dark-default'
    );

    this.header.style.top = '';

    if (this.breadcrumbs) {
      this.breadcrumbs.style.display = '';
    }

    this.header.classList.add('tw-space-y-arn-spacings-base');

    const title = this.header.querySelector('.arn-collection-title');
    if (title) {
      title.classList.remove('tw-hidden', 'sd:tw-block');
    }

    this.placeholder.style.display = 'none';

    const globalBannerSection = document.querySelector(
      '.arn-global-banner-section'
    );
    if (globalBannerSection) {
      globalBannerSection.classList.remove(
        'arn-global-banner-section--sticky'
      );
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('scroll', this.onScroll);
  }
}

customElements.define('arn-plp-sticky-header', ArnPlpStickyHeader);
